import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-navy-50 py-14 sm:py-20" data-id="element-245" data-mp="26xmsb2c31oej">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-246" data-mp="2bxix33sltjv5">
        <SectionHeading eyebrow="Ti suona familiare?" title="Se hai vissuto anche solo una di queste situazioni, questo sistema è per te" data-id="element-247" data-mp="2bvobdn9idnq0" />

        <div className="mt-10 space-y-3" data-id="element-248" data-mp="220e8yyf77ebp">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border border-navy-900/10 bg-white p-4 sm:p-5" data-id="element-249" data-mp="1o03froqf1nnd">
              <h3 className="flex gap-3 text-[14px] font-extrabold uppercase leading-snug text-navy-900 sm:text-base" data-id="element-250" data-mp="1sywvlnt6dqqp">
                <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-251" data-mp="3ibrw9vcapy9v" />
                {point.title}
              </h3>
              <p className="mt-2 pl-8 text-[14px] leading-relaxed text-navy-900/70 sm:text-[15px]" data-id="element-252" data-mp="1u1lmf3idph6q">
                {point.text}
              </p>
            </article>)}
        </div>

        <p className="mt-8 text-center text-[15px] font-extrabold uppercase leading-snug tracking-tight text-navy-900 sm:text-xl" data-id="element-253" data-mp="27utd8symy8nd">
          Se hai risposto “sì” anche solo a una di queste situazioni,
          <span className="block text-gold-600" data-id="element-254" data-mp="1b2ps7s6it2sw">
            il Sistema Maestro della TRT™ è stato creato per te.
          </span>
        </p>

        <div className="mt-8 flex justify-center" data-id="element-255" data-mp="1p3k1se5b19t5">
          <CtaBlock label="Sì, voglio il mio sistema clinico" note="Accesso immediato · Pagamento unico · 19 EUR" data-id="element-256" data-mp="1p04ongv6yaud" />
        </div>
      </div>
    </section>;
}